<template>
  <div class="text-start">
    <CourseNumberField
      :label="$t('course.courseDetails.certificateValidity')"
      :value="trainingCertificateValidity"
      @update:value="trainingCertificateValidity = $event"
      :isEditing="isEditing"
      css-class="subtitle-2 font-weight-regular textLight--text"
      :class="isEditing ? 'mb-6' : 'mb-4'"
    />
  </div>
</template>

<script>
import CourseNumberField from "@/app/course-module/components/course-details/CourseNumberField";

export default {
  name: "CourseValidity",
  components: { CourseNumberField },
  props: {
    training: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    trainingCertificateValidity: {
      get() {
        return this.training.certificateValidity ?? "";
      },
      set(value) {
        this.$emit("update:training", {
          ...this.training,
          certificateValidity: this.getInteger(value),
          hasChangesInCertificateValidity: true,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped />
